import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconGames: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.442 3.57608C13.0675 2.28843 11.2196 1.5 9.1875 1.5C4.94181 1.5 1.5 4.94181 1.5 9.1875C1.5 13.4332 4.94181 16.875 9.1875 16.875C11.2931 16.875 13.2009 16.0285 14.5893 14.6573L9 9L14.442 3.57608Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M6.375 4.875V7.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.875 6.375H7.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
